import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ts1 from '../../images/resource/author-1.jpg'
import ts2 from '../../images/resource/author-2.jpg'
import ts3 from '../../images/resource/author-3.jpg'

import bg from '../../images/background/8.jpg'


const Testimonial = (props) => {

    var settings = {
        dots: false,
        arrows: true,
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const testimonial = [
        {
            tsImg: ts1,
            Des: "Lush Minds brings structure and clarity to complex projects. Their research-driven insights helped us align our goals and deliver measurable community impact.",
            Title: 'Raktim Buragohain',
            Sub: "Project Coordinator, SELCO Foundation",
        },
        {
            tsImg: ts2,
            Des: "Lush Minds transformed how we approach market decisions. Their data-backed strategies helped us scale efficiently while keeping our brand vision intact.",
            Title: 'Arindam Dutta',
            Sub: "COO, Fork & Funnel",
        },
        {
            tsImg: ts3,
            Des: "Collaborating with Lush Minds offered a clear view of user needs. Their analytical depth and structured approach made every solution more purposeful and precise.",
            Title: 'Anupal Neog',
            Sub: "SDE, IQVIA",
        }

    ]
    return (

        <section className="testimonial-one">
            <div className="testimonial-one_pattern" style={{ backgroundImage: `url(${bg})` }}></div>
            <div className="auto-container">
                <div className="sec-title">
                    <div className="sec-title_title">What They Say</div>
                    <h2 className="sec-title_heading">Why People <br/> Prefer Us</h2>
                </div>
                <div className="two-item-carousel">
                    <Slider {...settings}>
                        {testimonial.map((tesmnl, tsm) => (
                            <div className="testimonial-block_one" key={tsm}>
                                <div className="testimonial-block_one-inner">
                                    <div className="testimonial-block_one-content">
                                        <div className="testimonial-block_one-text">{tesmnl.Des}</div>
                                        <div className="testimonial-block_one-rating">
                                            <span className="fa fa-star"></span>
                                            <span className="fa fa-star"></span>
                                            <span className="fa fa-star"></span>
                                            <span className="fa fa-star"></span>
                                            <span className="fa fa-star"></span>
                                        </div>
                                        <div className="testimonial-block_one-quote fi flaticon-quote"></div>
                                    </div>
                                    <div className="testimonial-block_one-lower">
                                        <div className="testimonial-block_one-author">
                                            <img src={tesmnl.tsImg} alt="" />
                                        </div>
                                        <strong>{tesmnl.Title}</strong>
                                        {tesmnl.Sub}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>

                </div>
            </div>
        </section>
    );
}

export default Testimonial;